import React, { useEffect, useMemo, useState } from 'react';
import { fetchHospitals } from '../api';
import { useMemberApp } from '../AppProvider';
import { careSearchSeed } from '../careProfile';
import CarePageHeader from '@/components/CarePageHeader';
import { sortHospitalsByRegion } from '@/lib/careDirectory';

export default function FindCarePage() {
  const { careProfile } = useMemberApp();
  const [hospitals, setHospitals] = useState([]);
  const [q, setQ] = useState(() => careSearchSeed(careProfile));
  const [seeded, setSeeded] = useState(false);

  useEffect(() => {
    fetchHospitals().then(setHospitals);
  }, []);

  useEffect(() => {
    if (seeded || !careProfile) return;
    const seed = careSearchSeed(careProfile);
    if (!seed) return;
    setQ((prev) => (prev.trim() ? prev : seed));
    setSeeded(true);
  }, [careProfile, seeded]);

  const shown = useMemo(() => {
    const query = q.trim().toLowerCase();
    const ranked = sortHospitalsByRegion(hospitals);
    return ranked.filter((h) => {
      if (!query) return true;
      return `${h.name} ${h.city} ${h.country} ${h.specialties || ''}`.toLowerCase().includes(query);
    }).slice(0, 12);
  }, [hospitals, q]);

  const lede = careProfile?.cancer_type
    ? `Centers matched to your care profile first. Search by city, name, or cancer type.`
    : 'Search verified cancer centers by city, name, or cancer type.';

  return (
    <div className="by-page care-page">
      <div className="by-center">
        <CarePageHeader title="Find care" lede={lede} showBackToApp={false} />
        <label className="by-field">
          <span>Search centers</span>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="City, center, or cancer type" />
        </label>
        <div className="by-list" style={{ marginTop: 16 }}>
          {shown.map((h) => (
            <div className="by-list-card" key={h.id || h.name}>
              <h3>{h.name}</h3>
              <p className="by-fine" style={{ textAlign: 'left' }}>
                {[h.city, h.state || h.country].filter(Boolean).join(', ')}
              </p>
              {h.website ? (
                <a className="by-btn by-btn-ghost" style={{ marginTop: 10 }} href={h.website} target="_blank" rel="noreferrer">
                  Center site
                </a>
              ) : null}
            </div>
          ))}
          {!shown.length ? <p className="by-lede">Try another city, name, or cancer type.</p> : null}
        </div>
      </div>
    </div>
  );
}
